import { deviceProfileTypes } from "../actions/deviceProfile";
import { DEFAULT_SCHEDULE } from "../../global/utility/scheduleTimeUtils";
const initialState = {
  isLoading: {
    devices: false,
    deviceTypes: false,
    isCreated: false,
    isDeleted: false,
    isActiveShipments: false,
  },
  isDownloaded: "",
  msg: "",
  shouldUpdate: false,
  ui: {
    notification: {
      isActive: false,
      type: "success",
      message: "",
      description: "",
      style: { backgroundColor: "#d4edda", color: "#155724" },
    },
    delete: {
      isOpen: false,
      id: null,
      name: "",
    },
    shipValidate: {
      id:"",
      actionType: "",
      hasActiveShipments:"",
      proceed: false
    },
    activeShipmentPopup:{
      isOpen: false,
      type: "",
      id:""
    },
    form: {
      isOpen: false,
      type: "",
      step: 1,
      isSaved: false,
      deviceTypes: [],
      alertGroups: [],
       fieldsUpdated: true,
      single: {
        id: null,
        name: "",
      },
      fields: {
        step1: {
          profileName: {
            isValid: true,
            isRequired: true,
            class: "",
            value: "",
            error: "",
          },
          profileType: {
            isValid: true,
            isRequired: true,
            class: "",
            value: "shipment",
            error: "",
          },
          deviceType: {
            isValid: true,
            isRequired: true,
            class: "",
            value: undefined,
            error: "",
          },
          description: {
            isValid: true,
            isRequired: false,
            class: "",
            value: "",
            error: "",
          },
          attributes: [],
          isDeviceTypeChange: false,
           devicemodel:[],
        },
        step2: {
          autoResolveForAllAlert: true,
        },
        step3: {
          currentLocationIndex: null,
          locations: [
            {
              currentLocation: "",
              existing: {
                shipping: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
                pointName: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                address: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                  mapBoxTheme: {
                    cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
                    variables: {
                      unit: "14px",
                      padding: "0.5em",
                      border: "1px solid rgba(111, 113, 113, 1)",
                      borderRadius: "4px",
                      boxShadow: "none",
                    },
                  },
                },
                latitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                longitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                radius: {
                  isValid: true,
                  class: "",
                  value: "",
                  error: "",
                },
                trigger: {
                  isValid: false,
                  class: "",
                  value: "entry and exit",
                  error: "",
                },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
              },
              new: {
                shipping: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
                pointName: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                address: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                  mapBoxTheme: {
                    cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
                    variables: {
                      unit: "14px",
                      padding: "0.5em",
                      border: "1px solid rgba(111, 113, 113, 1)",
                      borderRadius: "4px",
                      boxShadow: "none",
                    },
                  },
                },
                latitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                longitude: {
                  isValid: false,
                  class: "",
                  value: "",
                  error: "",
                },
                radius: {
                  isValid: true,
                  class: "",
                  value: "",
                  error: "",
                },
                trigger: {
                  isValid: false,
                  class: "",
                  value: "entry and exit",
                  error: "",
                },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
              },
            },
          ],
        },
        nonshipstep3: {
          nonshipsetalert: false,
          nonshipusecase:{
           useCase: {
            isValid: false,
            class: "",
            value: "Inventory management",
            error: "",
          },
          },
          inventoryMgmt: {
            assetthreshold: {
              isValid: false,
              class: "",
              value: "",
              error: "",
            },
           assettype: {
              isValid: false,
              class: "",
              value: [],
              error: "",
            },
          alerttype: {
            isValid: false,
            class: "",
            value: "notification",
            error: "",
          },
          alertgroup: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
          },
           nonshipbleloc: {
            locationzone: {
              isValid: false,
              class: "",
              value: [],
              error: "",
            },
            trigger: {
              isValid: false,
              class: "",
              value: "entry and exit",
              error: "",
            },
          alerttype: {
            isValid: false,
            class: "",
            value: "notification",
            error: "",
          },
          alertgroup: {
            isValid: false,
            class: "",
            value: undefined,
            error: "",
          },
          },
        },
        step4: {
          reportingFrequency: {
            value: {
              isValid: true,
              class: "",
              value: "5",
              error: "",
            },
            unit: {
              isValid: true,
              class: "",
              value: "minutes",
              error: "",
            },
          },
          monitorFrequency: {
            value: {
              isValid: true,
              class: "",
              value: "5",
              error: "",
            },
            unit: {
              isValid: true,
              class: "",
              value: "minutes",
              error: "",
            },
          },
        },
        location: {
          pointName: "",
          address: "",
          latitude: "",
          longitude: "",
          radius: "",
          isAdjustGeofanceOnMap: false,
          isFullScreen: false,
        },
      },
    },
  },
  filters: {
    profileNames: [],
    profileTypes: [],
    description: "",
    deviceTypes: [],
    lastUpdatedto: "",
    lastUpdatedfrom: "",
  },
  data: {
    pageSize: 10,
    currentPage: 1,
    count: 0,
    devices: [],
    query: {
      $sort: [{ field: "updatedon", order: "desc" }],
    },
  },
  error: null,
};

const deviceProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case deviceProfileTypes.FETCH_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          devices: true,
        },
        data: {
          ...state.data,
          //currentPage: action.payload ? action.payload : state.data.currentPage,
        },
      };
    case deviceProfileTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          devices: false,
        },
        filters: {
          ...state.filters,
          ...action.payload.filters,
        },
        ui: {
          ...state.ui,
          form: {
            ...state.ui.form,
            fieldsUpdated: true,
          },
        },
        data: {
          ...state.data,
          devices: action.payload.devices,
          currentPage: action.payload.page ?? state.data.currentPage,
          pageSize: action.payload.limit ?? state.data.pageSize,
          count: action.payload.totalrecords ?? state.data.count,
        },
        error: null,
      };
    case deviceProfileTypes.FETCH_ALL_ASSET_REQUEST: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetList: true,
        },
      };
    }
    case deviceProfileTypes.FETCH_ALL_ASSET_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetList: false,
        },
        data: {
          ...state.data,
          assetList: action.payload.assetList,
        },
        error: null,
      };
    case deviceProfileTypes.FETCH_ALL_ASSET_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          assetList: false,
        },
        data: {
          ...state.data,
          assetList: [],
        },
        error: action.payload,
      };
      case deviceProfileTypes.FETCH_ALL_LOCATION_REQUEST: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          locationList: true,
        },
      };
    }
    case deviceProfileTypes.FETCH_ALL_LOCATION_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          locationList: false,
        },
        data: {
          ...state.data,
          locationList: action.payload.locationList,
        },
        error: null,
      };
    case deviceProfileTypes.FETCH_ALL_LOCATION_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          locationList: false,
        },
        data: {
          ...state.data,
          locationList: [],
        },
        error: action.payload,
      };

    case deviceProfileTypes.UPDATE_FILTERS:
      return {
        ...state,
        shouldUpdate: !state.shouldUpdate,
        filters: {
          ...state.filters,
          ...action.payload.filters,
        },
        data: {
          ...state.data,
          query: {
            $sort: [
              { field: action.payload.field, order: action.payload.sort },
            ],
          },
        },
      };
    case deviceProfileTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          devices: false,
        },
        data: {
          ...state.data,
          alarms: [],
        },
        error: action.payload,
      };
    case deviceProfileTypes.UPDATE_UI:
      return {
        ...state,
        ui: {
          ...state.ui,
          [action.payload.key]: {
            ...state.ui[action.payload.key],
            ...action.payload.value,
          },
        },
      };
    case deviceProfileTypes.UPDATE_PAGINATION_REQUEST:
      return {
        ...state,
        shouldUpdate: action.payload.shouldUpdate,
        data: {
          ...state.data,
          ...action.payload.data,
        },
      };
    case deviceProfileTypes.DELETE_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isDeleted: true,
        },
        ui: {
          ...state.ui,
          notification: {
            isActive: false,
            type: "success",
            message: "",
            description: "",
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
        },
      };
    case deviceProfileTypes.DELETE_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isDeleted: false,
        },
        shouldUpdate: !state.shouldUpdate,
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "success",
            isActive: true,
            message: "Delete profile",
            description: action.payload,
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
          delete: {
            isOpen: false,
            id: null,
            name: "",
          },
        },
      };
    case deviceProfileTypes.DELETE_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isDeleted: false,
        },
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Delete profile",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
          delete: {
            isOpen: false,
            id: null,
            name: "",
          },
        },
      };

    case deviceProfileTypes.UPDATE_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isCreated: true,
        },
        ui: {
          ...state.ui,
          notification: {
            isActive: false,
            type: "success",
            message: "",
            description: "",
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
          form: {
            ...state.ui.form,
            fieldsUpdated: false,
          },
        },
      };
    case deviceProfileTypes.CREATE_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isCreated: true,
        },
        ui: {
          ...state.ui,
          notification: {
            isActive: false,
            type: "success",
            message: "",
            description: "",
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
        },
      };
    case deviceProfileTypes.CREATE_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isCreated: false,
        },
        shouldUpdate: !state.shouldUpdate,
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "success",
            isActive: true,
            message: "Create profile",
            description: action.payload,
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
          form: {
            ...state.ui.form,
            isOpen: false,
            type: "",
            step: 1,
            isSaved: false,
            deviceTypes: [],
            alertGroups: [],
            single: {
              id: null,
              name: "",
            },
            fields: {
              step1: {
                profileName: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: "",
                  error: "",
                },
                 profileType: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: "shipment",
                  error: "",
                },
                deviceType: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: undefined,
                  error: "",
                },
                description: {
                  isValid: true,
                  isRequired: false,
                  class: "",
                  value: "",
                  error: "",
                },
                attributes: [],
              },
              step2: {
                autoResolveForAllAlert: true,
              },
              step3: {
                locations: [
                  {
                    currentLocation: "",
                    existing: {     
                      shipping: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                      pointName: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      address: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      longitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      radius: {
                        isValid: true,
                        class: "",
                        value: "",
                        error: "",
                      },
                      trigger: {
                        isValid: false,
                        class: "",
                        value: "entry and exit",
                        error: "",
                      },
                      alerttype: {
                        isValid: false,
                        class: "",
                        value: "notification",
                        error: "",
                      },
                      alertgroup: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                    },
                    new: {
                      shipping: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                      pointName: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      address: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      longitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      radius: {
                        isValid: true,
                        class: "",
                        value: "",
                        error: "",
                      },
                      trigger: {
                        isValid: false,
                        class: "",
                        value: "entry and exit",
                        error: "",
                      },
                      alerttype: {
                        isValid: false,
                        class: "",
                        value: "notification",
                        error: "",
                      },
                      alertgroup: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                    },
                  },
                ],
              },
                nonshipstep3: {
                nonshipsetalert: false,
                nonshipusecase:{
                useCase: {
                  isValid: false,
                  class: "",
                  value: "Inventory management",
                  error: "",
                },
                },
                inventoryMgmt: {
                  assetthreshold: {
                    isValid: false,
                    class: "",
                    value: "",
                    error: "",
                  },
                assettype: {
                    isValid: false,
                    class: "",
                    value: [],
                    error: "",
                  },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
                },
                nonshipbleloc: {
                  locationzone: {
                    isValid: false,
                    class: "",
                    value: [],
                    error: "",
                  },
                  trigger: {
                    isValid: false,
                    class: "",
                    value: "entry and exit",
                    error: "",
                  },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
                },
              },
              step4: {
                reportingFrequency: {
                  value: {
                    isValid: true,
                    class: "",
                    value: "5",
                    error: "",
                  },
                  unit: {
                    isValid: true,
                    class: "",
                    value: "minutes",
                    error: "",
                  },
                },
                monitorFrequency: {
                  value: {
                    isValid: true,
                    class: "",
                    value: "5",
                    error: "",
                  },
                  unit: {
                    isValid: true,
                    class: "",
                    value: "minutes",
                    error: "",
                  },
                },
              },
            },
          },
        },
      };
    case deviceProfileTypes.CREATE_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isCreated: false,
        },
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Create profile",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
          form: {
            isOpen: false,
            type: "",
            step: 1,
            isSaved: false,
            deviceTypes: [],
            alertGroups: [],
            single: {
              id: null,
              name: "",
            },
            fields: {
              step1: {
                profileName: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: "",
                  error: "",
                },
                 profileType: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: "shipment",
                  error: "",
                },
                deviceType: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: undefined,
                  error: "",
                },
                description: {
                  isValid: true,
                  isRequired: false,
                  class: "",
                  value: "",
                  error: "",
                },
                attributes: [],
              },
              step2: {
                autoResolveForAllAlert: true,
              },
              step3: {
                locations: [
                  {
                    currentLocation: "",
                    existing: {
                      shipping: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                      pointName: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      address: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      longitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      radius: {
                        isValid: true,
                        class: "",
                        value: "",
                        error: "",
                      },
                      trigger: {
                        isValid: false,
                        class: "",
                        value: "entry and exit",
                        error: "",
                      },
                      alerttype: {
                        isValid: false,
                        class: "",
                        value: "notification",
                        error: "",
                      },
                      alertgroup: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                    },
                    new: {
                      shipping: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                      pointName: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      address: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      longitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      radius: {
                        isValid: true,
                        class: "",
                        value: "",
                        error: "",
                      },
                      trigger: {
                        isValid: false,
                        class: "",
                        value: "entry and exit",
                        error: "",
                      },
                      alerttype: {
                        isValid: false,
                        class: "",
                        value: "notification",
                        error: "",
                      },
                      alertgroup: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                    },
                  },
                ],
              },
                nonshipstep3: {
                nonshipsetalert: false,
                nonshipusecase:{
                useCase: {
                  isValid: false,
                  class: "",
                  value: "Inventory management",
                  error: "",
                },
                },
                inventoryMgmt: {
                  assetthreshold: {
                    isValid: false,
                    class: "",
                    value: "",
                    error: "",
                  },
                assettype: {
                    isValid: false,
                    class: "",
                    value: [],
                    error: "",
                  },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
                },
                nonshipbleloc: {
                  locationzone: {
                    isValid: false,
                    class: "",
                    value: [],
                    error: "",
                  },
                  trigger: {
                    isValid: false,
                    class: "",
                    value: "entry and exit",
                    error: "",
                  },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
                },
              },
              step4: {
                reportingFrequency: {
                  value: {
                    isValid: true,
                    class: "",
                    value: "5",
                    error: "",
                  },
                  unit: {
                    isValid: true,
                    class: "",
                    value: "minutes",
                    error: "",
                  },
                },
                monitorFrequency: {
                  value: {
                    isValid: true,
                    class: "",
                    value: "5",
                    error: "",
                  },
                  unit: {
                    isValid: true,
                    class: "",
                    value: "minutes",
                    error: "",
                  },
                },
              },
            },
          },
        },
      };

    case deviceProfileTypes.FETCH_DEVICETYPE_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceTypes: true,
        },
      };

    case deviceProfileTypes.FETCH_DEVICETYPE_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceTypes: false,
        },
        ui: {
          ...state.ui,
          form: {
            ...state.ui.form,
            ...action.payload,
          },
        },
      };

    case deviceProfileTypes.FETCH_DEVICETYPE_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceTypes: false,
        },
        ui: {
          ...state.ui,
          form: {
            ...state.ui.form,
            deviceTypes: [],
            alertGroups: [],
          },
        },
      };

    case deviceProfileTypes.UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isCreated: false,
        },
        shouldUpdate: !state.shouldUpdate,
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "success",
            isActive: true,
            message: "Edit profile",
            description: action.payload,
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
          form: {
            ...state.ui.form,
            isOpen: false,
            type: "",
            step: 1,
            isSaved: false,
            deviceTypes: [],
            alertGroups: [],
            fieldsUpdated: true,
            single: {
              id: null,
              name: "",
            },
            fields: {
              step1: {
                profileName: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: "",
                  error: "",
                },
                 profileType: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: "shipment",
                  error: "",
                },
                deviceType: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: undefined,
                  error: "",
                },
                description: {
                  isValid: true,
                  isRequired: false,
                  class: "",
                  value: "",
                  error: "",
                },
                attributes: [],
              },
              step2: {
                autoResolveForAllAlert: true,
              },
              step3: {
                locations: [
                  {
                    currentLocation: "",
                    existing: {
                      shipping: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                      pointName: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      address: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      longitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      radius: {
                        isValid: true,
                        class: "",
                        value: "",
                        error: "",
                      },
                      trigger: {
                        isValid: false,
                        class: "",
                        value: "entry and exit",
                        error: "",
                      },
                      alerttype: {
                        isValid: false,
                        class: "",
                        value: "notification",
                        error: "",
                      },
                      alertgroup: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                    },
                    new: {
                      shipping: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                      pointName: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      address: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      longitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      radius: {
                        isValid: true,
                        class: "",
                        value: "",
                        error: "",
                      },
                      trigger: {
                        isValid: false,
                        class: "",
                        value: "entry and exit",
                        error: "",
                      },
                      alerttype: {
                        isValid: false,
                        class: "",
                        value: "notification",
                        error: "",
                      },
                      alertgroup: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                    },
                  },
                ],
              },
                nonshipstep3: {
                nonshipsetalert: false,
                nonshipusecase:{
                useCase: {
                  isValid: false,
                  class: "",
                  value: "Inventory management",
                  error: "",
                },
                },
                inventoryMgmt: {
                  assetthreshold: {
                    isValid: false,
                    class: "",
                    value: "",
                    error: "",
                  },
                assettype: {
                    isValid: false,
                    class: "",
                    value: [],
                    error: "",
                  },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
                },
                nonshipbleloc: {
                  locationzone: {
                    isValid: false,
                    class: "",
                    value: [],
                    error: "",
                  },
                  trigger: {
                    isValid: false,
                    class: "",
                    value: "entry and exit",
                    error: "",
                  },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
                },
              },
              step4: {
                reportingFrequency: {
                  value: {
                    isValid: true,
                    class: "",
                    value: "5",
                    error: "",
                  },
                  unit: {
                    isValid: true,
                    class: "",
                    value: "minutes",
                    error: "",
                  },
                },
                monitorFrequency: {
                  value: {
                    isValid: true,
                    class: "",
                    value: "5",
                    error: "",
                  },
                  unit: {
                    isValid: true,
                    class: "",
                    value: "minutes",
                    error: "",
                  },
                },
              },
            },
          },
        },
      };
    case deviceProfileTypes.UPDATE_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isCreated: false,
        },
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Edit profile",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
          form: {
            isOpen: false,
            type: "",
            step: 1,
            isSaved: false,
            fieldsUpdated: true,
            deviceTypes: [],
            alertGroups: [],
            single: {
              id: null,
              name: "",
            },
            fields: {
              step1: {
                profileName: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: "",
                  error: "",
                },
                 profileType: {
                isValid: true,
                isRequired: true,
                class: "",
                value: "shipment",
                error: "",
              },
                deviceType: {
                  isValid: true,
                  isRequired: true,
                  class: "",
                  value: undefined,
                  error: "",
                },
                description: {
                  isValid: true,
                  isRequired: false,
                  class: "",
                  value: "",
                  error: "",
                },
                attributes: [],
              },
              step2: {
                autoResolveForAllAlert: true,
              },
              step3: {
                locations: [
                  {
                    currentLocation: "",
                    existing: {
                      shipping: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                      pointName: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      address: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      longitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      radius: {
                        isValid: true,
                        class: "",
                        value: "",
                        error: "",
                      },
                      trigger: {
                        isValid: false,
                        class: "",
                        value: "entry and exit",
                        error: "",
                      },
                      alerttype: {
                        isValid: false,
                        class: "",
                        value: "notification",
                        error: "",
                      },
                      alertgroup: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                    },
                    new: {
                      shipping: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                      pointName: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      address: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                          .Input {
                              height: 43px;
                              font-size: 1rem;
                              font-weight: 400;
                              color: #212529;
                              font-family: system-ui;
                              pointer-events: none;
                          }
                          .ClearBtn {
                              display: none !important;
                          }
                      `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      longitude: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                      },
                      radius: {
                        isValid: true,
                        class: "",
                        value: "",
                        error: "",
                      },
                      trigger: {
                        isValid: false,
                        class: "",
                        value: "entry and exit",
                        error: "",
                      },
                      alerttype: {
                        isValid: false,
                        class: "",
                        value: "notification",
                        error: "",
                      },
                      alertgroup: {
                        isValid: false,
                        class: "",
                        value: undefined,
                        error: "",
                      },
                    },
                  },
                ],
              },
                nonshipstep3: {
                nonshipsetalert: false,
                nonshipusecase:{
                useCase: {
                  isValid: false,
                  class: "",
                  value: "Inventory management",
                  error: "",
                },
                },
                inventoryMgmt: {
                  assetthreshold: {
                    isValid: false,
                    class: "",
                    value: "",
                    error: "",
                  },
                assettype: {
                    isValid: false,
                    class: "",
                    value: [],
                    error: "",
                  },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
                },
                nonshipbleloc: {
                  locationzone: {
                    isValid: false,
                    class: "",
                    value: [],
                    error: "",
                  },
                  trigger: {
                    isValid: false,
                    class: "",
                    value: "entry and exit",
                    error: "",
                  },
                alerttype: {
                  isValid: false,
                  class: "",
                  value: "notification",
                  error: "",
                },
                alertgroup: {
                  isValid: false,
                  class: "",
                  value: undefined,
                  error: "",
                },
                },
              },
              step4: {
                reportingFrequency: {
                  value: {
                    isValid: true,
                    class: "",
                    value: "5",
                    error: "",
                  },
                  unit: {
                    isValid: true,
                    class: "",
                    value: "minutes",
                    error: "",
                  },
                },
                monitorFrequency: {
                  value: {
                    isValid: true,
                    class: "",
                    value: "5",
                    error: "",
                  },
                  unit: {
                    isValid: true,
                    class: "",
                    value: "minutess",
                    error: "",
                  },
                },
              },
            },
          },
        },
      };
    case deviceProfileTypes.DOWNLOAD_REQUEST:
      return {
        ...state,
        isDownloaded: "Downloading....",
        ui: {
          ...state.ui,
          notification: {
            isActive: false,
            type: "success",
            message: "Export",
            description: "Export in progress",
            style: { backgroundColor: "#E3F2FD", color: "#000" },
          },
        },
      };
    case deviceProfileTypes.DOWNLOAD_SUCCESS:
      return {
        ...state,
        isDownloaded: "Downloaded",
        ui: {
          ...state.ui,
          notification: {
            isActive: true,
            type: "success",
            message: "Export",
            description: "Export completed successfully",
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
        },
      };
    case deviceProfileTypes.SHIPMENT_VALIDATION_REQUEST: {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isActiveShipments: true,
        },
      };
    }
    case deviceProfileTypes.SHIPMENT_VALIDATION_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          shipValidate: {
            ...state.ui.shipValidate,
            id: action.payload.id,
            actionType: action.payload.actionType,
            hasActiveShipments: action.payload.hasActiveShipments,
          }
        }
      };

    case deviceProfileTypes.SHIPMENT_VALIDATION_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          isActiveShipments: false,
        error: action.payload,
        },
        hasActiveShipments:false,
      };

    case deviceProfileTypes.UPDATE_ATTR_SCHEDULE:
      return {
        ...state,
        ui: {
          ...state.ui,
          form: {
            ...state.ui.form,
            fields: {
              ...state.ui.form.fields,
              step2: {
                ...state.ui.form.fields.step2,
                [action.payload.attrKey]: {
                  ...state.ui.form.fields.step2[action.payload.attrKey],
                  schedule: action.payload.schedule,
                },
              },
            },
          },
        },
      };

    case deviceProfileTypes.DOWNLOAD_FAILURE:
      return {
        ...state,
        isDownloaded: "Something Went Wrong",
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Export",
            description: "Unable to serialize unrecognized input",
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
        error: action.payload,
      };

    default:
      return state;
  }
};

export default deviceProfileReducer;
